import T from './types';
import { withData as loader } from '@ott/utility-loader';

import prepareDates from './helpers/prepareDates';

import times from 'lodash/times';

export const DAYS_TO_SHOW = 90;
const TODAY = new Date();
const DAY_IM_MS = 1000 * 60 * 60 * 24;
function getDates() {
  return times(DAYS_TO_SHOW, (i) => {
    return new Date(TODAY.getTime() + (i + 1) * DAY_IM_MS);
  });
}

function formatDate(date) {
  return date.toISOString().split('T')[0];
}

function getInitialDates() {
  const dates = getDates();

  return dates.map((date) => {
    return [formatDate(date), 0];
  });
}

const initialPricesByDays = {
  meta: {},
  prices: prepareDates(getInitialDates()),
};

const initialState = {
  nights: 7,
  adults: 2,
  toCountryId: 298795, // Turkey
  fromCityId: 524901, // Moscow
  pricesByDays: loader.initial(initialPricesByDays),
};

export default (state = initialState, action) => {
  switch (action.type) {
    case T.CHANGE_NIGHTS: {
      return {
        ...state,
        nights: action.nights,
      };
    }

    case T.CHANGE_DESTINATION_COUNTRY: {
      return {
        ...state,
        toCountryId: action.toCountryId,
      };
    }

    case T.CHANGE_DEPARTURE_CITY: {
      return {
        ...state,
        fromCityId: action.fromCityId,
      };
    }

    /* Prices By Days */

    case T.GET_PRICES_BY_DAYS: {
      return {
        ...state,
        pricesByDays: loader.begin(initialPricesByDays),
      };
    }

    case T.GET_PRICES_BY_DAYS_SUCCESS: {
      const { meta, prices } = action.result;

      return {
        ...state,
        pricesByDays: loader.success({
          meta,
          prices: prepareDates(prices),
        }),
      };
    }

    case T.GET_PRICES_BY_DAYS_FAIL: {
      return {
        ...state,
        pricesByDays: {
          ...loader.error(action.error),
          data: initialPricesByDays,
        },
      };
    }

    default:
      return state;
  }
};
